document.addEventListener('change', (event) => {
  const option = event.target.closest('.card__variant-option');
  if (!option) return;

  const card = option.closest('product-card');
  if (!card) return;

  const variantUrl = option.dataset.productUrl;
  const variantId = option.dataset.variantId;

  if (variantUrl) {
    card.querySelectorAll('.js-prod-link').forEach((link) => {
      link.href = variantUrl;
    });

    card.querySelectorAll('.js-quick-add').forEach((button) => {
      button.dataset.productUrl = variantUrl;
    });
  }

  card.querySelectorAll('.js-product-form input[name="id"]').forEach((input) => {
    input.value = variantId;
  });

  const priceTemplate = card.querySelector(`template[data-card-variant-price="${CSS.escape(variantId)}"]`);
  const price = card.querySelector('.card__price');

  if (priceTemplate && price) {
    price.replaceChildren(priceTemplate.content.cloneNode(true));
  }
});
